'use client';

import type { ReactNode } from 'react';

import { useRouter } from 'next/navigation';

import Button from '@gds/Button/Button';

type Props = {
  href: string;
  className?: string;
  children: ReactNode;
};

const FinanceTileButton = ({ href, className, children }: Props) => {
  const router = useRouter();

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    router.push(href, { scroll: false });
  };

  return (
    <Button
      variant="link"
      size="small"
      className={className}
      onClick={handleClick}
      data-test-id="finance-tile-button"
    >
      {children}
    </Button>
  );
};

export { FinanceTileButton };
